import React from 'react';
import moment from 'moment';

import TableHeader from './TableHeader';

const UserCoinsList = ({
  userCoinTransactions = [],
  userId = null,
}) => {
  return(
    <React.Fragment>
      <div className='Table Table--user-coins-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'Amount'
            },
            {
              label: 'Date'
            },
            {
              label: 'Coin Details'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {userCoinTransactions.map((userCoinTransaction) => (
          <div
            className='Table__row'
            key='userCoinTransaction.id'
            data-x='userCoinTransaction'
          >
            <div className='Table__col'>{userCoinTransaction.amount}</div>
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: userCoinTransaction.createdAt !== null ?
                    moment(userCoinTransaction.createdAt).format('YYYY-MM-DD HH:mm')
                    :
                    'N/A'
                }
              }
            />
            <div className='Table__col'>{userCoinTransaction.coinType}</div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default UserCoinsList
